// Étape 13 — Admin « Facturation » : factures & avoirs, encaissements en attente (virement reçu), rétractations à rembourser
import { useState, useEffect } from "react";
import axios from "axios";
import { C, Btn, Input, Select, FormField, Alert, Spinner, fmtEur, DateInput } from "./shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const hdr = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("auprea_token")}` } });
const eur = fmtEur;
const fd = (iso) => iso ? new Date(iso).toLocaleDateString("fr-FR") : "—";
const today = () => new Date().toISOString().slice(0, 10);
const th = { textAlign: "left", padding: "9px 12px", fontSize: 10, color: C.muted, textTransform: "uppercase", letterSpacing: ".07em", fontWeight: 700 };
const td = { padding: "9px 12px", fontSize: 12, color: C.mid, borderTop: `.5px solid ${C.border}` };
const box = { background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, overflow: "hidden" };

const blob = async (url, name) => {
  const r = await axios.get(url, { ...hdr(), responseType: "blob" });
  const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = name; a.click();
};
const voir = async (inv) => {
  const r = await axios.get(`${API}/invoices/${inv.id}/download`, { ...hdr(), responseType: "blob" });
  window.open(URL.createObjectURL(r.data), "_blank");
};

const Liste = ({ conseillers }) => {
  const [f, setF] = useState({ debut: "", fin: "", consultant: "", type: "" });
  const [mois, setMois] = useState(today().slice(0, 7));
  const [d, setD] = useState(null);
  const q = new URLSearchParams(f).toString();
  useEffect(() => { axios.get(`${API}/admin/facturation?${q}`, hdr()).then(r => setD(r.data)); }, [q]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (<>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr) auto", gap: 10, alignItems: "end", marginBottom: 14 }}>
      <FormField label="Du"><DateInput value={f.debut} onChange={v => setF({ ...f, debut: v })} data-testid="fact-debut" /></FormField>
      <FormField label="Au"><DateInput value={f.fin} onChange={v => setF({ ...f, fin: v })} error={f.debut && f.fin && f.fin < f.debut ? "Date invalide : la fin est antérieure au début" : ""} data-testid="fact-fin" /></FormField>
      <FormField label="Consultant"><Select value={f.consultant} onChange={set("consultant")} data-testid="fact-consultant">
        <option value="">Tous</option>{(conseillers || []).map(c => <option key={c.id} value={c.id}>{c.prenom} {c.nom}</option>)}</Select></FormField>
      <FormField label="Type"><Select value={f.type} onChange={set("type")} data-testid="fact-type"><option value="">Factures et avoirs</option><option value="facture">Factures</option><option value="avoir">Avoirs</option></Select></FormField>
      <Btn onClick={() => blob(`${API}/admin/facturation/export.csv?${q}`, "facturation-auprea.csv")} data-testid="fact-export-csv">⬇ Export CSV</Btn>
    </div>
    <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 14, fontSize: 12, color: C.mid }}>
      ZIP mensuel des PDF : <Input type="month" value={mois} onChange={(e) => setMois(e.target.value)} style={{ width: 170 }} data-testid="fact-mois" />
      <Btn small onClick={() => blob(`${API}/admin/facturation/zip?mois=${mois}`, `factures-${mois}.zip`)} data-testid="fact-export-zip">⬇ Télécharger le ZIP</Btn>
    </div>
    {!d ? <Spinner /> : (<>
      <div style={{ fontSize: 12, color: C.mid, marginBottom: 8 }} data-testid="fact-totaux">{d.totaux.nb_factures} facture(s) · {d.totaux.nb_avoirs} avoir(s) · Total {eur(d.totaux.total_ttc)} TTC ({eur(d.totaux.total_ht)} HT)</div>
      <div style={box}><table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead><tr style={{ background: C.gray2 }}>{["Numéro", "Date", "Encaissement", "Client", "Consultant", "Moyen", "HT", "TTC", ""].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
        <tbody>{d.items.map(x => (
          <tr key={x.id} data-testid={`fact-row-${x.numero}`}>
            <td style={{ ...td, fontFamily: "monospace", fontWeight: 700, color: x.type === "avoir" ? C.red : C.navy }}>{x.numero}</td>
            <td style={td}>{fd(x.date)}</td><td style={td}>{fd(x.date_encaissement)}</td>
            <td style={td}>{x.client_nom || x.email}</td><td style={td}>{x.consultant}</td>
            <td style={td}>{x.moyen === "virement" ? "Virement" : x.moyen === "manuel" ? "Manuel" : "Carte"}</td>
            <td style={td}>{eur(x.montant_ht)}</td><td style={{ ...td, fontWeight: 700, color: C.navy }}>{eur(x.montant_ttc)}</td>
            <td style={{ ...td, textAlign: "right" }}><Btn small onClick={() => voir(x)} data-testid={`fact-pdf-${x.numero}`}>PDF</Btn></td>
          </tr>))}
          {d.items.length === 0 && <tr><td colSpan={9} style={{ ...td, textAlign: "center", padding: 30 }}>Aucune pièce sur la période.</td></tr>}
        </tbody></table></div>
    </>)}
  </>);
};

const LigneAttente = ({ x, reload }) => {
  const [date, setDate] = useState(today());
  const [err, setErr] = useState("");
  const recu = async () => {
    if (!window.confirm(`Confirmer la réception du virement de ${eur(x.montant)} (réf. ${x.ref_virement}) ? La facture sera émise et envoyée au client.`)) return;
    try { await axios.post(`${API}/admin/paiements/${x.parcours_id}/virement-recu`, { echeance: x.index, date }, hdr()); reload(); }
    catch (e) { setErr(e?.response?.data?.detail || "Erreur"); }
  };
  const ok = x.exigible && ["a_payer", "virement_annonce"].includes(x.statut);
  return (
    <tr data-testid={`attente-${x.parcours_id}-${x.index}`}>
      <td style={{ ...td, fontWeight: 700, color: C.navy }}>N°{x.numero}</td><td style={td}>{x.client}</td><td style={td}>{x.consultant}</td>
      <td style={td}>{x.libelle}</td><td style={{ ...td, fontWeight: 700 }}>{eur(x.montant)}</td>
      <td style={td}>{{ a_payer: x.exigible ? "À régler" : `Exigible le ${fd(x.exigible_at)}`, virement_annonce: `Virement annoncé le ${fd(x.virement_annonce_at)}`, en_attente_jalon: "En attente du jalon" }[x.statut]}</td>
      <td style={{ ...td, fontFamily: "monospace", fontSize: 11 }}>{x.ref_virement}</td>
      <td style={td}>{ok && <div style={{ display: "flex", gap: 6 }}><Input type="date" value={date} onChange={(e) => setDate(e.target.value)} style={{ width: 140 }} data-testid={`attente-date-${x.parcours_id}`} />
        <Btn small variant="teal" onClick={recu} data-testid={`attente-recu-${x.parcours_id}-${x.index}`}>Virement reçu</Btn></div>}
        {err && <div style={{ color: C.red, fontSize: 11 }}>{err}</div>}</td>
    </tr>
  );
};

const Attente = () => {
  const [rows, setRows] = useState(null);
  const load = () => axios.get(`${API}/admin/paiements/attente`, hdr()).then(r => setRows(r.data));
  useEffect(() => { load(); }, []);
  if (!rows) return <Spinner />;
  return (<>
    <Alert type="info"><span>ℹ</span><span>« Payé » uniquement par le webhook Stripe (carte) ou par le bouton « Virement reçu » ci-dessous, après rapprochement bancaire.</span></Alert>
    <div style={box}><table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead><tr style={{ background: C.gray2 }}>{["Proposition", "Client", "Consultant", "Échéance", "Montant", "Statut", "Référence", "Action"].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
      <tbody>{rows.map(x => <LigneAttente key={`${x.parcours_id}-${x.index}`} x={x} reload={load} />)}
        {rows.length === 0 && <tr><td colSpan={8} style={{ ...td, textAlign: "center", padding: 30 }} data-testid="attente-vide">Aucun encaissement en attente.</td></tr>}
      </tbody></table></div>
  </>);
};

const Retractation = ({ x, reload }) => {
  const total = Math.max(x.etapes.length, 1);
  const [faites, setFaites] = useState(0);
  const [montant, setMontant] = useState(x.encaisse);
  const [mode, setMode] = useState(x.paye_par_carte ? "stripe" : "virement");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const setEtapes = (n) => { setFaites(n); setMontant(Math.round(x.encaisse * (1 - n / total) * 100) / 100); };
  const go = async () => {
    if (!window.confirm(`Rembourser ${eur(montant)} et émettre l'avoir ?`)) return;
    setBusy(true); setErr("");
    try { await axios.post(`${API}/admin/retractations/${x.parcours_id}/rembourser`, { montant: Number(montant), mode, etapes_realisees: faites }, hdr()); reload(); }
    catch (e) { setErr(e?.response?.data?.detail || "Erreur"); }
    setBusy(false);
  };
  const r = x.remboursement;
  return (
    <div data-testid={`retr-${x.parcours_id}`} style={{ background: "#fff", border: `.5px solid ${r ? C.border : C.red}`, borderRadius: 12, padding: 16, marginBottom: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: C.navy, fontWeight: 700 }}>
        <span>Proposition N°{x.numero} · {x.client}</span>
        <span style={{ color: r ? C.mid : C.red }}>{r ? "Rétractée — traitée" : `À rembourser avant le ${fd(x.limite)}`}</span>
      </div>
      <div style={{ fontSize: 12, color: C.mid, margin: "6px 0 10px" }}>Rétractation du {fd(x.retractation?.at)} ({x.retractation?.source}) · Encaissé : <strong>{eur(x.encaisse)}</strong> · Démarrage anticipé : {x.demarrage_anticipe ? "oui" : "non"}</div>
      {r ? <div style={{ fontSize: 12 }} data-testid={`retr-fait-${x.parcours_id}`}>Remboursé {eur(r.montant)} ({r.mode}) le {fd(r.date)}{r.avoir ? ` · avoir ${r.avoir}` : ""}</div> : (<>
        {x.etapes.length > 0 && x.demarrage_anticipe && <FormField label={`Étapes déjà réalisées (prorata sur ${total})`}>
          <Input type="number" min={0} max={total} value={faites} onChange={(e) => setEtapes(Math.min(total, Math.max(0, Number(e.target.value))))} data-testid={`retr-etapes-${x.parcours_id}`} /></FormField>}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: 10, alignItems: "end", marginTop: 8 }}>
          <FormField label="Montant à rembourser (modifiable)"><Input type="number" step="0.01" value={montant} onChange={(e) => setMontant(e.target.value)} data-testid={`retr-montant-${x.parcours_id}`} /></FormField>
          <FormField label="Moyen"><Select value={mode} onChange={(e) => setMode(e.target.value)} data-testid={`retr-mode-${x.parcours_id}`}>
            {x.paye_par_carte && <option value="stripe">Remboursement carte (Stripe)</option>}
            <option value="virement">Virement effectué (confirmation)</option><option value="manuel">Autre (confirmation manuelle)</option></Select></FormField>
          <Btn variant="gold" disabled={busy} onClick={go} data-testid={`retr-rembourser-${x.parcours_id}`}>{busy ? "Traitement en cours…" : Number(montant) > 0 ? "Rembourser et émettre l'avoir" : "Clore sans remboursement"}</Btn>
        </div>
        {err && <div style={{ color: C.red, fontSize: 12, marginTop: 8 }} data-testid={`retr-erreur-${x.parcours_id}`}>{err}</div>}
      </>)}
    </div>
  );
};

const Retractations = () => {
  const [rows, setRows] = useState(null);
  const load = () => axios.get(`${API}/admin/retractations`, hdr()).then(r => setRows(r.data));
  useEffect(() => { load(); }, []);
  if (!rows) return <Spinner />;
  if (!rows.length) return <div style={{ padding: 30, textAlign: "center", color: C.muted }} data-testid="retr-vide">Aucune rétractation.</div>;
  return rows.map(x => <Retractation key={x.parcours_id} x={x} reload={load} />);
};

const TABS = [["liste", "Factures & avoirs"], ["attente", "Encaissements en attente"], ["retractations", "Rétractations & remboursements"]];

export default function FacturationAdmin({ conseillers, initialTab = "liste" }) {
  const [tab, setTab] = useState(initialTab);
  useEffect(() => setTab(initialTab), [initialTab]);
  return (
    <div data-testid="facturation-admin">
      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        {TABS.map(([k, l]) => <Btn key={k} small variant={tab === k ? "gold" : "ghost"} onClick={() => setTab(k)} data-testid={`fact-tab-${k}`}>{l}</Btn>)}
      </div>
      {tab === "liste" && <Liste conseillers={conseillers} />}
      {tab === "attente" && <Attente />}
      {tab === "retractations" && <Retractations />}
    </div>
  );
}
